import ApiService from "@/common/api/api.service";

let endpoint = "Proposta";

const Rubricas = {

    setEndpoint(endpointSelecionado) {
        endpoint = endpointSelecionado;
    },

    salvar(form, rubrica) {
        if(form.id){
            return ApiService.put(`${endpoint}/${rubrica}`, form);
        }else{
            return ApiService.post(`${endpoint}/${rubrica}`, form);
        }
    },

    deletar(form, rubrica) {
        return ApiService.delete(`${endpoint}/${rubrica}`, form);
    },

    buscar(id, rubrica){
        return ApiService.get(`${endpoint}/${rubrica}?propostaId=${id}`);
    }
}

export default Rubricas;